import React, {useContext, useEffect, useState} from "react";
import {Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import PropTypes from "prop-types";
import {useDefaultEndpoints} from "../../../lib/api/useDefaultEndpoints";
import {toast} from "react-toastify";
import {useForm} from "react-hook-form";
import {handleInputChange} from "../../../lib/utils/handleInputChange";
import {t} from "i18next";
import {IsFormValueState} from "../../directories/legalEntities";

export const showDangerToast = e => toast(e, {type: 'error'});
export const showSuccessToast = e => toast(e, {type: 'success'});

const EditModal = (
    {
        entityName, EditForm, entry, triggerModal, isOpened, size = 'md', edit,
        extraButtons = [], onSuccess = undefined, title, onSuccessCb = undefined,
        isFormData = false, isUploadOnlyFile = false, disabled = false
    }
) => {
    const isFormValue = useContext(IsFormValueState);

    const {createEntry, editEntry} = useDefaultEndpoints(entityName, isFormData, isUploadOnlyFile);
    const [entity, setEntity] = useState({});

    const defaultValues = {
        ...entry
    }

    if (entityName === 'arrivals') {
        defaultValues.start_time = entry?.start_time || '';
        defaultValues.end_time = entry?.end_time || '';
    }

    const {handleSubmit, control, errors, register, reset} = useForm({
        reValidateMode: 'onBlur',
        defaultValue: defaultValues,
    });

    const handleInput = (e, setEntity) => {
        const {name, value} = handleInputChange(e)
        setEntity(entity => ({...entity, [name]: value}))
        return {name, value};
    }

    const createOrUpdate = (v) => {
        const value = isFormValue ? { ...entity, ...v } : entity

        if (entity.id) editEntry(entity.id, value)
            .then((res) => {
                showSuccessToast(t('common.success'));
                triggerModal();
                onSuccessCb && onSuccessCb(res);
            })
            .catch(showDangerToast)
        else createEntry(value).then((res) => {
            showSuccessToast(t('common.success'));
            triggerModal();
            onSuccessCb && onSuccessCb(res);
        })
            .catch(showDangerToast);
    };

    const onSubmit = handleSubmit((v) => {
        onSuccess ? onSuccess(entity) : createOrUpdate(v);
    })

    useEffect(() => {
        setEntity(entry || {});
        isFormValue && reset(entry);
    }, [entry])

    return (
        <Modal isOpen={isOpened} toggle={triggerModal} className={'edit-modal'} size={size}>
            <ModalHeader>{title || (entity.id ? t('generic.editModal.edit') : t('generic.editModal.create'))}</ModalHeader>
            <ModalBody>
                {EditForm({entity, setEntity, control, errors, handleInput, register})}
            </ModalBody>
            {edit && <ModalFooter>
                <div>
                    <Row>
                        {extraButtons.map((Button, id) => <Col key={id}>{Button({entity, setEntity})}</Col>)}
                    </Row>
                </div>
                <div>
                    <Row>
                        <Col>
                            <Button color="primary" onClick={onSubmit} disabled={disabled}>
                                {t('generic.okButton')}
                            </Button>
                        </Col>
                        <Col>
                            <Button color="secondary" outline onClick={triggerModal} disabled={disabled}>
                                {t('generic.cancelButton')}
                            </Button>
                        </Col>
                    </Row>
                </div>
            </ModalFooter>}
        </Modal>
    )
};

EditModal.propTypes = {
    entityName: PropTypes.string.isRequired,
    EditForm: PropTypes.func.isRequired,
    entry: PropTypes.object,
    triggerModal: PropTypes.func.isRequired,
    onSuccess: PropTypes.func,
    onSuccessCb: PropTypes.func,
    isOpened: PropTypes.bool.isRequired,
    size: PropTypes.oneOf(['lg', '', 'sm']),
    extraButtons: PropTypes.array,
    title: PropTypes.string,
    edit: PropTypes.bool
}

export default EditModal;


